// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"389":"a4ff0d8a","475":"b6718765","580":"9ae73d01","687":"a4ff0d8a","761":"a4ff0d8a","972":"a4ff0d8a"}[chunkId] + ".chunk.css";
};